import React, { useEffect } from 'react'
import PropTypes from 'prop-types';
//@core
import { recordLink } from 'utilities/tagging';
import { getDepositProduct } from 'utilities/taggingDeposits';
// components
import DepositOfferItem from '../../offers/UI/depositOffersItem/depositOfferItem';
import DepositsMultiOffersItem from '../../offers/UI/depositMultiOfferItem/depositsMultiOffersItem';
// constants
import {
  DEFERRAL_DEPOSIT_OFFER_ACTION_EVENT,
  DEFERRAL_DEPOSIT_OFFER_CATEGORY_EVENT,
  DEFERRAL_DEPOSIT_POST_EXPIRATION_OFFER_CATEGORY_EVENT,
  DEFERRAL_DEPOSIT_MULTI_OFFER_ACTION_EVENT,
  DEFERRAL_DEPOSIT_OFFER_BUTTON_ACTION_EVENT,
  DEFERRAL_DEPOSIT_OFFERS_BUTTON_ACTION_EVENT,
  DEFERRAL_DEPOSIT_REQUEST_RENEW_CATEGORY_EVENT,
  DEFERRAL_DEPOSIT_REQUEST_RENEW_ACTION_EVENT,
  DEFERRAL_DEPOSIT_REQUEST_CONDITIONS_ACTION_EVENT
} from 'constants/tagging';
import { EXPIRED_DEPOSIT_RENEWAL_FLOW, RENEWAL_DEPOSIT_FLOW } from '../constants/depositsConstants';
// helpers
import { getIsFullProfitability } from 'utilities/depositHelper'
import DepositRenovatedItem from '../../offers/UI/depositRenovatedItem/depositRenovatedItem';
import { formatWithoutRound, parseSpanishNumberToFloat, formatInterest } from 'utilities/currencyHelper';
import { goToOffersLanding, goToDeposits, getImpositionToHideOffer } from '../../offers/helpers/depositOffersItemHelper';
import { useOpenDepositRemoveOfferModal } from '../depositRemoveOfferModal/hooks/depositRemoveOfferModal'
import DepositRemoveOfferModal from '../depositRemoveOfferModal/depositRemoveOfferModal';

const DepositsRenovationFooterBase = ({
  history,
  renovationState,
  onOpenInfo,
  offerData,
  goToDepositsCallback,
  taggingData,
  originCountry,
  immDeposit,
  immProfile,
  isLargeDisplayOption,
  onHideOfferPost,
  hideOfferPostState,
  resetHideDepositOfferPost,
}) => {
  const { openRemoveOfferModal, handleOpenRemoveOfferModal } = useOpenDepositRemoveOfferModal({ hideOfferPostState, resetHideDepositOfferPost })

  const {
    havePostRenovation,
    haveRenewable,
    haveRenovated,
    haveMultiImpositions,
    haveComplexRenewable
  } = renovationState;

  const handleRenovatedTagging = (showConditions) => {
    if (!taggingData) {
      return;
    }
    const { standard, type, subType } = taggingData;
    const taggingProductName = getDepositProduct(type, subType, standard);

    const actionEvent = showConditions
      ? DEFERRAL_DEPOSIT_REQUEST_CONDITIONS_ACTION_EVENT
      : DEFERRAL_DEPOSIT_REQUEST_RENEW_ACTION_EVENT

    recordLink(DEFERRAL_DEPOSIT_REQUEST_RENEW_CATEGORY_EVENT, actionEvent, taggingProductName)
  }

  const handleRenewableTagging = (isMulti = false, isPostRenovation = false) => {
    if (!taggingData) {
      return;
    }
    const { standard, type, subType } = taggingData;
    const taggingProductName = getDepositProduct(type, subType, standard);

    const actionEvent = isMulti ? DEFERRAL_DEPOSIT_MULTI_OFFER_ACTION_EVENT : DEFERRAL_DEPOSIT_OFFER_ACTION_EVENT
    const categoryEvent = isPostRenovation ? DEFERRAL_DEPOSIT_POST_EXPIRATION_OFFER_CATEGORY_EVENT : DEFERRAL_DEPOSIT_OFFER_CATEGORY_EVENT;
    recordLink(categoryEvent, actionEvent, taggingProductName)
  }

  useEffect(() => {
    if (haveRenovated) {
      handleRenovatedTagging(false)
    }

    if (haveMultiImpositions) {
      handleRenewableTagging(true, havePostRenovation)
    }

    if (haveRenewable && !haveMultiImpositions) {
      handleRenewableTagging(false, havePostRenovation)
    }
  }, [])

  const handleOpenModal = () => {
    handleRenovatedTagging(true)
    onOpenInfo && onOpenInfo()
  }

  const handleSubmitDataToRemoveOffer = () => {
    const data = getImpositionToHideOffer(immDeposit.get('contract'), immDeposit.getIn(['impositionList', 'byId']))
    onHideOfferPost(data)
  }

  const handleFooterOfferClick = (depositIdentify, offersLanding = false, isPostRenovation = false, flowId) => {
    if (taggingData) {
      const { standard, type, subType } = taggingData;
      const taggingProductName = getDepositProduct(type, subType, standard);
      const taggingActionEvent = haveComplexRenewable ? DEFERRAL_DEPOSIT_OFFERS_BUTTON_ACTION_EVENT : DEFERRAL_DEPOSIT_OFFER_BUTTON_ACTION_EVENT;
      const taggingCategoryEvent = havePostRenovation ? DEFERRAL_DEPOSIT_POST_EXPIRATION_OFFER_CATEGORY_EVENT : DEFERRAL_DEPOSIT_OFFER_CATEGORY_EVENT;
      recordLink(taggingCategoryEvent, taggingActionEvent, taggingProductName);
    }

    if (offersLanding) {
      goToOffersLanding(history, immDeposit.get('id'), flowId);
    } else {
      const url = isPostRenovation ? EXPIRED_DEPOSIT_RENEWAL_FLOW : RENEWAL_DEPOSIT_FLOW;
      goToDeposits(history, depositIdentify, immDeposit, offerData, url, goToDepositsCallback);
    }
  }

  const renderFooterOffer = () => {
      const { tin, tae, months, daysLeft, expirationDate, amount, productId: depositIdentify, isRobinson, examplesIndex, isPostRenovation, flowId } = offerData;

      const clientFirstName = immProfile.get('nombreCliente', '').trim();
      const showFullValues = getIsFullProfitability(originCountry);

      const taeValue = showFullValues ? formatInterest(tae, true, false) : null;
      const tinValue = formatInterest(tin, true, false);
      const formattedAmount = formatWithoutRound(parseSpanishNumberToFloat(amount), 2);
      return (
        <DepositOfferItem
          daysLeft={daysLeft}
          expirationDate={expirationDate}
          examplesIndex={examplesIndex}
          isLargeDisplayOption={isLargeDisplayOption}
          isRobinson={isRobinson}
          isPostRenovation={isPostRenovation}
          tae={taeValue}
          tin={tinValue}
          months={months}
          name={clientFirstName}
          amount={formattedAmount}
          handleClick={() => handleFooterOfferClick(depositIdentify, haveComplexRenewable, isPostRenovation, flowId)}
          onOpenRemoveOfferModal={handleOpenRemoveOfferModal}
          multipleOffers={haveComplexRenewable}
        />
      )
  }

  const renderFooterMulti = () => {
    const { daysLeft, expirationDate, isPostRenovation, isRobinson } = offerData;
    const clientFirstName = immProfile.get('nombreCliente', '').trim();
    return (
      <DepositsMultiOffersItem 
        daysLeft={daysLeft} 
        dueDate={expirationDate} 
        isLargeDisplayOption={isLargeDisplayOption}
        isPostRenovation={isPostRenovation} 
        isRobinson={isRobinson} 
        name={clientFirstName} 
        onOpenRemoveOfferModal={handleOpenRemoveOfferModal}
      />
    )
  }

  const renderRenovatedFooter = () => {
    const { expirationDate } = offerData;
    return (
      <DepositRenovatedItem dueDate={expirationDate} handleClick={handleOpenModal} />
    )
  }

  return (
    <div>
      {haveRenewable && !haveMultiImpositions && renderFooterOffer()}
      {haveRenewable && haveMultiImpositions && renderFooterMulti()}
      {haveRenovated && renderRenovatedFooter()}
      {haveRenewable && __CONTACT_CENTER__ && (
        <DepositRemoveOfferModal
          showModal={openRemoveOfferModal}
          onSubmit={handleSubmitDataToRemoveOffer}
          onCloseModal={handleOpenRemoveOfferModal}
          hideOfferPostState={hideOfferPostState}
        />
      )}
    </div>);
};

export const DepositsRenovationFooter = React.memo(DepositsRenovationFooterBase);

DepositsRenovationFooterBase.defaultProps = {
  isLargeDisplayOption: false,
  onHideOfferPost: () => {}
};

DepositsRenovationFooterBase.propTypes = {
  isLargeDisplayOption: PropTypes.bool,
  history: PropTypes.object.isRequired,
  renovationState: PropTypes.object.isRequired,
  onOpenInfo: PropTypes.func,
  immFlagBasedFeatures: PropTypes.object.isRequired,
  immRenewalOffer: PropTypes.array,
  taggingData: PropTypes.object,
  immDeposit: PropTypes.object,
  originCountry: PropTypes.string,
  goToDepositsCallback: PropTypes.func.isRequired,
  onHideOfferPost: PropTypes.func.isRequired,
  hideOfferPostState: PropTypes.object.isRequired,
};
